(function() {
	'use strict';

	angular.module('paymentRates').directive('paymentRatesSearch',
			paymentRatesSearch).directive('focusOn', function($timeout) {
		return {
			restrict : 'A',
			link : function(vm, $element, $attr) {
				vm.$watch($attr.focusOn, function(_focusVal) {
					$timeout(function() {
						_focusVal ? $element[0].focus() : $element[0].blur();
					});
				});
			}
		}
	});

	function paymentRatesSearch(MessageService, $stateParams) {
		return {
			restrict : 'EA',
			scope : {
				openSearchPanel : '&',
				onSearchSubmit : '&',
				crewTypes : '=',
				showSearchArea : '='
			},
			templateUrl : 'payment-rates/directives/payment-rates-search-derective.tpl.html',
			replace : false,
			controllerAs : 'searchPanel',
			bindToController : true,

			controller : [
					'$scope',
					function($scope) {
						var vm = this;

						vm.model = {
							crewType : {
								crewTypeCode : ''
							}
						};

						vm.displaySearchArea = function() {
							vm.showSearchArea = !vm.showSearchArea;
							vm.openSearchPanel();
						};

						vm.onSearchClick = function() {
							if (!!vm.model.crewType.crewTypeCode) {
								vm
										.onSearchSubmit({
											'searchParam' : vm.model.crewType.crewTypeCode
										});
							} else {
								MessageService
										.warning(MessageService.MESSAGES.PAYMENT_RATES.ERROR_SEARCH);
							}
						};

					} ],
			link : function(scope, element, attrs) {

			}
		};
	}
}());
